import {
  AD_GALLERY_CREATE_FORMATS,
  ANALYTICS_EVENTS,
  ANALYTICS_PROPERTY_KEYS,
  COMPONENT_OUTCOMES,
  DCM_PAGES,
  GALLERY_ACTIONS,
  GALLERY_ENTITY_TYPES,
  GALLERY_TABS,
  NAVIGATION_DESTINATIONS,
} from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export type TrackNavigationTabClickedParams = {
  destination: (typeof NAVIGATION_DESTINATIONS)[keyof typeof NAVIGATION_DESTINATIONS];
};

/** Header / nav bar clicks — separate from route-based Page Viewed. */
export const trackNavigationTabClicked = ({ destination }: TrackNavigationTabClickedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.NAVIGATION_TAB_CLICKED, {
    [ANALYTICS_PROPERTY_KEYS.NAVIGATION_DESTINATION]: destination,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};

export type TrackAdGalleryTabViewedParams = {
  tab: (typeof GALLERY_TABS)[keyof typeof GALLERY_TABS];
};

export const trackAdGalleryTabViewed = ({ tab }: TrackAdGalleryTabViewedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.GALLERY_TAB_VIEWED, {
    [ANALYTICS_PROPERTY_KEYS.GALLERY_TAB]: tab,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.AD_GALLERY,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};

export type TrackAdGalleryActionPerformedParams = {
  action: (typeof GALLERY_ACTIONS)[keyof typeof GALLERY_ACTIONS];
  entityType: (typeof GALLERY_ENTITY_TYPES)[keyof typeof GALLERY_ENTITY_TYPES];
  creativeId?: string;
  assetId?: string;
  assetSourceId?: string;
};

export const trackAdGalleryActionPerformed = ({
  action,
  entityType,
  creativeId,
  assetId,
  assetSourceId,
}: TrackAdGalleryActionPerformedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.GALLERY_ACTION_TAKEN, {
    [ANALYTICS_PROPERTY_KEYS.GALLERY_ACTION]: action,
    [ANALYTICS_PROPERTY_KEYS.GALLERY_ENTITY_TYPE]: entityType,
    [ANALYTICS_PROPERTY_KEYS.CREATIVE_ID]: creativeId,
    [ANALYTICS_PROPERTY_KEYS.ASSET_ID]: assetId,
    [ANALYTICS_PROPERTY_KEYS.ASSET_SOURCE_ID]: assetSourceId,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.AD_GALLERY,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};

export type TrackAdGalleryCreateFormatSelectedParams = {
  format: (typeof AD_GALLERY_CREATE_FORMATS)[keyof typeof AD_GALLERY_CREATE_FORMATS];
};

export const trackAdGalleryCreateFormatSelected = ({ format }: TrackAdGalleryCreateFormatSelectedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.AD_FORMAT_SELECTED, {
    [ANALYTICS_PROPERTY_KEYS.AD_FORMAT]: format,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.AD_GALLERY,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};
